import React from 'react';
import TestsCertifications from '../../components/dashboards/components/TestsCertifications';

const Tests = () => {
  return <TestsCertifications />;
};

export default Tests;
